import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  icon: {
    display: 'flex',
    alignItems: 'center'
  }
})

export default function Alert(props) {
  const classes = useStyles()

  return <MuiAlert classes={{ icon: classes.icon }} elevation={6} variant="filled" {...props} />;
}
